<script setup>
import { MagnifyingGlassIcon } from "@heroicons/vue/20/solid";
import { onMounted, ref } from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
});

defineEmits(["update:modelValue"]);

const input = ref(null);

onMounted(() => {
  if (input.value.hasAttribute("autofocus")) {
    input.value.focus();
  }
});

defineExpose({ focus: () => input.value.focus() });
</script>

<template>
  <div class="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
    <div class="flex flex-1">
      <label for="search-field" class="sr-only">{{ $t("msg.search") }}</label>
      <div class="relative w-full">
        <MagnifyingGlassIcon
          class="pointer-events-none absolute inset-y-0 left-0 h-full w-5 text-[#ccd1c4]"
          aria-hidden="true"
        />
        <input
          id="search-field"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value)"
          ref="input"
          class="block h-full w-full border-0 bg-background py-0 pl-8 pr-0 text-white focus:outline-none focus:ring-0 sm:text-sm"
          :placeholder="$t('msg.search')"
          type="search"
          name="search-field"
        />
      </div>
    </div>
  </div>
</template>
